import { Injectable } from "@angular/core";
import { Socket, SocketIoConfig } from "ngx-socket-io";
import * as io from "socket.io-client";
import { environment } from "../../environments/environment";
import { log } from "../_helpers/log";
import { AuthenticationService } from "./authentication.service";

const token = localStorage.getItem("REFRESH_TOKEN");
const url = environment.api;
const config: SocketIoConfig = {
  url: url,
  options: {
    query: {
      auth: token ? `${token}` : undefined, // TODO implement token from local storage and check if token exists.
    },
  },
};

@Injectable({
  providedIn: "root",
})
export class CustomSocket extends Socket {
  constructor(public authService: AuthenticationService) {
    super(config);
    this.authService.currentUser.subscribe((newUser) => {
      if (newUser?.token) {
        this.recreateSocket(newUser.refreshToken);
      }
    });
  }

  recreateSocket(token: string) {
    log("recreated socket");

    this.ioSocket.disconnect();
    const newOptions: any = {
      namespace: "/",
      auth: {
        token: token,
        type: 'user'
      }
    };
    const ioFunc = (io as any).default ? (io as any).default : io;
    this.ioSocket = ioFunc(url, newOptions);

    this.ioSocket.connect();
  }
}
